export default {
  users: [],
  internalUsers: [],
  userInfos: {
    id: null,
    email: null,
    name: null,
    username: null,
    role: {
      id: null,
      name: null
    },
    originalBearer: null
  },
  isOriginalUser: true
}
